/**
 * Cart upsell recommendations — reads the lookup embedded by Liquid
 * (<script id="upsell-lookup-data">), selects items per cart, and renders
 * the slider. Lookup is now computed live in Liquid from the upsell
 * config metafields — no precomputed shop metafield and no runtime API
 * fetch.
 *
 * Shape: { types: { "TypeA": [...], ... }, fallback: [...] }
 */
(function () {
  'use strict';

  var container = document.getElementById('upsell-recommendations');
  if (!container) return;

  // Prevent any legacy webpack JS from double-initializing.
  container.dataset.upsellManaged = 'true';

  var slidesWrapper = document.getElementById('upsell-slides');
  var lastCartKey = null;

  // Parse the embedded lookup once.
  var cachedLookup;
  function readEmbeddedLookup() {
    if (cachedLookup !== undefined) return cachedLookup;
    try {
      var el = document.getElementById('upsell-lookup-data');
      if (!el) { cachedLookup = null; return null; }
      var parsed = JSON.parse(el.textContent);
      if (!parsed) { cachedLookup = null; return null; }
      cachedLookup = {
        types: parsed.types || {},
        fallback: parsed.fallback || [],
      };
    } catch (e) {
      cachedLookup = null;
    }
    return cachedLookup;
  }

  function buildFromLookup(cart, perSlide) {
    var lookup = readEmbeddedLookup();
    if (!lookup) return [];
    var out = [];
    var seen = {};
    cart.handles.forEach(function (h) { seen[h] = true; });
    for (var i = 0; i < cart.types.length; i++) {
      var list = lookup.types[cart.types[i]] || lookup.fallback;
      for (var j = 0; j < list.length; j++) {
        var p = list[j];
        if (!p || !p.handle) continue;
        if (seen[p.handle]) continue;
        seen[p.handle] = true;
        out.push(p);
        if (out.length >= perSlide) return out;
      }
    }
    // If no cart items matched and we still have nothing, fall back.
    if (out.length === 0) {
      for (var k = 0; k < lookup.fallback.length; k++) {
        var fp = lookup.fallback[k];
        if (!fp || !fp.handle || seen[fp.handle]) continue;
        seen[fp.handle] = true;
        out.push(fp);
        if (out.length >= perSlide) return out;
      }
    }
    return out;
  }

  function resizeImage(url, width) {
    if (!url) return '';
    if (!url.includes('cdn.shopify.com')) return url;
    return url.replace(/(\.\w+)(\?|$)/, '_' + width + 'x$1$2');
  }

  function buildSlideHtml(product, index) {
    var img = resizeImage(product.image, 400);
    return '<div class="upsell-slide">'
      + '<div class="upsell-slide__image-wrap">'
      + '<a href="' + product.url + '">'
      + '<img src="' + img + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">'
      + '</a>'
      + '</div>'
      + '<div class="upsell-slide__info">'
      + '<a href="' + product.url + '">'
      + '<span class="upsell-slide__title">' + product.title + '</span>'
      + '</a>'
      + '<span class="upsell-slide__price"><span class="money">' + product.price + '</span></span>'
      + '</div>'
      + '<form method="post" action="/cart/add" class="upsell-slide__form">'
      + '<input type="hidden" name="form_type" value="product">'
      + '<input type="hidden" name="id" value="' + product.variantId + '">'
      + '<div class="js-quick-submit" data-index="' + index + '">'
      + '<button type="button" name="add" class="global-button global-button--primary add_to_cart upsell-slide__add-btn">'
      + 'Add To Cart'
      + '</button>'
      + '</div>'
      + '</form>'
      + '</div>';
  }

  function initArrows() {
    document.querySelectorAll('[id="upsell-recommendations"]').forEach(function (root) {
      var prevBtn = root.querySelector('.upsell-arrow--prev');
      var nextBtn = root.querySelector('.upsell-arrow--next');
      var slides = root.querySelector('[id="upsell-slides"]');
      if (!prevBtn || !nextBtn || !slides) return;
      function getScrollAmount() {
        var slide = slides.querySelector('.upsell-slide');
        if (!slide) return 150;
        return slide.offsetWidth + 10;
      }
      nextBtn.onclick = function () { slides.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }); };
      prevBtn.onclick = function () { slides.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }); };
    });
  }

  function renderProducts(products) {
    if (!products.length) {
      document.querySelectorAll('[id="upsell-recommendations"]').forEach(function (el) {
        el.style.display = 'none';
      });
      return;
    }

    var html = '';
    for (var i = 0; i < products.length; i++) {
      html += buildSlideHtml(products[i], i);
    }
    document.querySelectorAll('[id="upsell-slides"]').forEach(function (el) {
      el.innerHTML = html;
    });
    document.querySelectorAll('[id="upsell-recommendations"]').forEach(function (el) {
      el.style.display = '';
    });
    initArrows();
  }

  // Quick-add — delegated so it works in both desktop and mobile cloned containers.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.upsell-slide__add-btn');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('form');
    if (!form) return;

    var variantId = form.querySelector('input[name="id"]').value;
    btn.textContent = 'ADDING...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: { _source: 'upsell' } }),
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.textContent = 'ADDED!';
        lastCartKey = null;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        // refreshCart triggers the upsell re-render via the wrapper below.
        if (typeof window.refreshCart === 'function') window.refreshCart(cart);
        setTimeout(function () {
          btn.textContent = 'Add To Cart';
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.textContent = 'Add To Cart';
        btn.disabled = false;
      });
  });

  function getCartData() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var types = [];
        var handles = [];
        var typesSeen = {};
        (cart.items || []).forEach(function (item) {
          handles.push(item.handle);
          if (item.product_type && !typesSeen[item.product_type]) {
            typesSeen[item.product_type] = true;
            types.push(item.product_type);
          }
        });
        return { types: types, handles: handles };
      });
  }

  function fetchAndRender() {
    getCartData().then(function (cart) {
      var cartKey = cart.types.join(',') + '|' + cart.handles.sort().join(',');
      if (cartKey === lastCartKey) return;
      var products = buildFromLookup(cart, 12);
      lastCartKey = cartKey;
      renderProducts(products);
    }).catch(function () {
      lastCartKey = null;
      renderProducts([]);
    });
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(fetchAndRender);
  } else {
    fetchAndRender();
  }

  // Re-render after the theme's refreshCart() runs (authoritative cart state).
  // Covers upsell quick-add / add-ons / bundle-kit which call window.refreshCart
  // explicitly. Does NOT cover the main PDP ATC: app.js.liquid calls its local
  // `refreshCart` directly (line ~733), bypassing the window property.
  function wrapRefreshCart() {
    if (typeof window.refreshCart !== 'function') {
      setTimeout(wrapRefreshCart, 100);
      return;
    }
    if (window.refreshCart.__upsellWrapped) return;
    var original = window.refreshCart;
    window.refreshCart = function () {
      original.apply(this, arguments);
      lastCartKey = null;
      fetchAndRender();
    };
    window.refreshCart.__upsellWrapped = true;
  }
  wrapRefreshCart();

  // Fallback trigger that catches every ATC path: watch for the cart drawer
  // opening (.cart-container gaining the 'active' class). Main PDP ATC adds
  // the class directly in app.js.liquid, so the observer fires there too.
  // fetchAndRender short-circuits via lastCartKey if the cart hasn't changed.
  function installDrawerOpenHook() {
    var containers = document.querySelectorAll('.cart-container');
    if (!containers.length) {
      setTimeout(installDrawerOpenHook, 200);
      return;
    }
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.attributeName === 'class' && m.target.classList.contains('active')) {
          fetchAndRender();
          return;
        }
      }
    });
    containers.forEach(function (el) {
      observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }
  installDrawerOpenHook();

  window.refreshUpsellRecommendations = fetchAndRender;
})();
